import { render, staticRenderFns } from "./AutoSaveStatus.vue?vue&type=template&id=362508d0"
import script from "./AutoSaveStatus.vue?vue&type=script&lang=js"
export * from "./AutoSaveStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports